import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface contactUsState {
	isLoading: boolean;
	contactUsList: any;
	totalContactUs: number;
	contactUsDetail: any;
}

const initialState: contactUsState = {
	isLoading: false,
	contactUsList: [],
	totalContactUs: 0,
	contactUsDetail: {}
};

const contactUsSlice = createSlice({
	name: 'contactUs',
	initialState,
	reducers: {
		getcontactUsListInIt: state => {
			state.isLoading = true;
			state.contactUsList = [];
			state.totalContactUs = 0;
		},
		getcontactUsListSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			state.contactUsList = [...data.querys];
			state.totalContactUs = data.count;
		},
		getcontactUsListError: state => {
			state.isLoading = false;
			state.totalContactUs = 0;
			state.contactUsList = [];
		},
		getcontactUsByIdInIt: state => {
			state.isLoading = true;
			state.contactUsList = [];
		},
		getcontactUsByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			// console.log(data.query);
			state.contactUsDetail = data.query;
		},
		getcontactUsByIdError: state => {
			state.isLoading = false;
		},
		clearcontactUsDetail: state => {
			state.contactUsDetail = {};
		},
		replycontactUsByIdInIt: state => {
			state.isLoading = true;
			// state.contactUsList = [];
		},
		replycontactUsByIdSuccess: state => {
			state.isLoading = false;
		},
		replycontactUsByIdError: state => {
			state.isLoading = false;
		}
	}
});
export const {
	getcontactUsListError,
	getcontactUsListInIt,
	getcontactUsListSuccess,
	getcontactUsByIdError,
	getcontactUsByIdInIt,
	getcontactUsByIdSuccess,
	clearcontactUsDetail,
	replycontactUsByIdError,
	replycontactUsByIdInIt,
	replycontactUsByIdSuccess
} = contactUsSlice.actions;

export default contactUsSlice.reducer;
